module.exports = __webpack_public_path__ + "img/plus.742c2166.svg";